// import msg from './MsgDialog/MsgDialog';
// let plugins = {}

// plugins.install = (Vue) => {
//     Vue.prototype.$msg = '我是msg';
//     Vue.prototype.$myMethd = () => {//全局方法；可以this.$myMethd调用；
//         console.log("woshifangfa");
        
//     };
//     Vue.directive('focus',{//自动获取焦点
//         inserted:function(el){
//             el.focus()//el指当前元素；
//         }
//     })
//     Vue.component(msg.name,msg);

// }

// export default plugins;


// 1.路径；
// 2.是否查找子目录；
// 3.正则匹配vue;
const requireComponent = require.context('./',true , /\.vue$/);
const install = (Vue) => {
    if (install.installed) return//注册了return；
    install.installed//没有注册去注册；
    requireComponent.keys().map(component => {
        //拿到组建；
        const config = requireComponent(component);
        //.default.name//拿到组件名
        const componentName = config.default.name;
        //注册组件
        Vue.component(componentName , config.default || config)
    })
}
export default {
    install
}